import { render, staticRenderFns } from "./yc-sales-customer.vue?vue&type=template&id=6ac36551&"
import script from "./yc-sales-customer.vue?vue&type=script&lang=js&"
export * from "./yc-sales-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports